import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/lib/LanguageContext";
import HomePage from "@/pages/HomePage";

function App() {
    return (
        <LanguageProvider>
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="*" element={<HomePage />} />
                    </Routes>
                </BrowserRouter>
            </div>
        </LanguageProvider>
    );
}

export default App;
